module.exports = __webpack_public_path__ + "img/pt-br.057f3318.svg";